import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center justify-center md:justify-between bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "flex flex-col items-center md:flex-row justify-between" }
const _hoisted_3 = { class: "max-w-lg w-full md:w-56 lg:max-w-xs" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_5 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_6 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_7 = { class: "flex flex-row mr-auto" }
const _hoisted_8 = { class: "py-6" }
const _hoisted_9 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_10 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }

import { inject, onMounted, ref, watch } from "vue";
import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import DataTable from "@/components/tools/DataTable.vue";
import Navbar from "@/components/tools/Navbar.vue";
import Pagination from "@/components/tools/Pagination.vue";
import { formatNumber, translate } from "@/utils/tools";
import DateSelector from "@/components/tools/DateSelector.vue";
// import LoyaltyInfoFilterDialog from "../../components/dialogs/LoyaltyInfoFilterDialog.vue"
import LoyaltyPointRequestApprovalDialog from "../../components/dialogs/LoyaltyPointRequestApprovalDialog.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PointRequest',
  setup(__props) {

dayjs.extend(localizedFormat);

const SearchIcon = require("@heroicons/vue/solid/SearchIcon");

const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const route = useRoute();
const router = useRouter();
const dataRows = ref([]);
const isLoaded = ref(false);
const resettleData = ref({});
const advanceFilterModal = ref<boolean>(false);
const detailDialogModal = ref<boolean>(false);
const showErrorDetail = ref<boolean>(false);
const errorMessage = ref<string>("");
const approvalModal = ref<boolean>(false);
const selectedRow = ref({});

const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  search: "",
  sort: [["id", "DESC"]],
});
const filterForm = ref({
  username: undefined,
  userId: undefined,
  from: null,
  to: null,
  // remark: null,
  // action: null
});

const edit = (e: any) => {
  selectedRow.value = e;
  approvalModal.value = true;
};

const doSort = (attName: string) => {
  const index = columns.value.findIndex((column) => column.label === attName);
  if (!columns.value[index].sort) {
    return;
  }

  columns.value[index].isSorted = !columns.value[index].isSorted;
  const { sort } = pageConfig.value;
  const mode = sort[0][1];
  let formattedAttName = "";
  if (attName === "Created Date") formattedAttName = "id";
  sort[0] = [
    formattedAttName || attName.toLowerCase(),
    mode === "DESC" ? "ASC" : "DESC",
  ];
  fetchPageData(true);
};

const filterModal = (flag?: number) => {
  if (flag === 1) {
    fetchPageData(true);
  } else {
    fetchPageData(false);
  }
  advanceFilterModal.value = false;
  detailDialogModal.value = false;
};

const onSearch = (payload: { from: null; to: null }) => {
  filterForm.value.from = payload.from;
  filterForm.value.to = payload.to;
  fetchPageData(true);
};

const fetchPageData = async (reset = false) => {
  isLoaded.value = false;
  let { page, rowsPerPage, sort } = pageConfig.value;

  const { username, userId, from, to } = filterForm.value;
  // let sort = [["created_at", "DESC"]]
  // let sort = sortBy.value.length ? sortBy.value : [["created_at", "DESC"]];
  let offset = (page - 1) * rowsPerPage;
  if (reset) {
    offset = 0;
    pageConfig.value.page = 1;
    page = 1;
  }

  const payload: any = {
    userId: userId,
    username: username || pageConfig.value.search || null,
    page: page,
    pageSize: rowsPerPage,
    startDate: from,
    endDate: to,
    orderBy: [sort[0]],
    status: "pending",
    // search: pageConfig.value.search
  };

  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/point/adjust`
  const { rows, count } = await axios
    .post(url, payload)
    .then(({ data }) => data);

  pageConfig.value.dataLength = rows.length;

  dataRows.value = rows;
  pageConfig.value.pageCount = Math.ceil(count / rowsPerPage);
  pageConfig.value.count = count;

  pageConfig.value = {
    ...pageConfig.value,
  };
  /** update url to persist page config */
  window.history.replaceState(
    {},
    document.title,
    `?${stringify({ page, rowsPerPage })}`
  );
  isLoaded.value = true;
};
const columns = ref([
  {
    label: translate("messages.pointRequest.username"),
    field: "username",
    isSorted: false,
    sort: true,
    isFunction: true,
    class: (data: any) => "text-blue-500 cursor-pointer",
    function: (data: any) => router.push(`/players/${data.userId}`),
  },
  {
    label: translate("messages.pointRequest.amount"),
    field: "amount",
    isSorted: false,
    sort: true,
    format: (data: any) => data.amount,
    class: (data: any) => {
      if (Number(data.amount) < 0 || data.action === "POINT_BURN") {
        return "text-red-500";
      } else if (data.action === "POINT_ADJUST") {
        return "text-yellow-500";
      } else {
        return "text-green-500";
      }
    },
  },
  {
    label: translate("messages.pointRequest.requestedBy"),
    field: "createdBy",
    isSorted: false,
    sort: false,
  },
  {
    label: translate("messages.pointRequest.createdDate"),
    field: "createdAt",
    align: "left",
    sort: true,
    isSorted: false,
    format: (data: any) => dayjs(data.createdAt).locale("th").format("LLL"),
  },
  {
    label: "",
    field: "",
    isEdit: true,
    sort: false,
    checkValue: (data: any) =>
      `${translate("messages.pointRequest.approve")}/${translate(
        "messages.pointRequest.reject"
      )}`,
  },
]);

watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = Number(route.query.page) || 1;
    fetchPageData();
  }
);
onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, {
      title: _ctx.$t('messages.pointRequest.loyaltyPointRequest')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(SearchIcon), {
                class: "h-5 w-5",
                "aria-hidden": "true"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              id: "search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.value.search) = $event)),
              class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
              placeholder: "Search...",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (fetchPageData(true)), ["enter"])),
              type: "search",
              name: "search"
            }, null, 544), [
              [_vModelText, pageConfig.value.search]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(DateSelector, { onSearch: onSearch })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(DataTable, {
            columns: columns.value,
            data: dataRows.value,
            onSort: doSort,
            onEdit: edit,
            isLoaded: isLoaded.value
          }, null, 8, ["columns", "data", "isLoaded"])
        ]),
        _createVNode(Pagination, {
          config: pageConfig.value,
          "onUpdate:config": _cache[2] || (_cache[2] = ($event: any) => ((pageConfig).value = $event)),
          onChangePage: _cache[3] || (_cache[3] = () => {})
        }, null, 8, ["config"]),
        _createVNode(LoyaltyPointRequestApprovalDialog, {
          show: approvalModal.value,
          "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((approvalModal).value = $event)),
          form: selectedRow.value,
          "onUpdate:form": _cache[5] || (_cache[5] = ($event: any) => ((selectedRow).value = $event)),
          onEdited: _cache[6] || (_cache[6] = ($event: any) => (fetchPageData())),
          onClosed: _cache[7] || (_cache[7] = ($event: any) => (fetchPageData()))
        }, null, 8, ["show", "form"])
      ])
    ])
  ], 64))
}
}

})